const PATHS = {
  PORTAL_LOGOUT_CALLBACK: "/oauth2/logout/callback", 
  PORTAL_LOGIN_CALLBACK: "/oauth2/login/callback", 
  LOGIN: "/authenticate", // Trang form-login
  PORTAL: "/", // Trang danh sách ứng dụng
  AUTHORIZE: "/authorize", // Endpoint để xác thực & consent
  FORBIDDEN: "/forbidden",
  NOT_FOUND: "/not-found",
  CLIENT_LOGOUT: "/client/logout/callback",
  REPORT: "/report", // Trang báo cáo
};

export default PATHS;